export const topBarHeight = 47
export const sideNavWidth = 240
export const navbarHeight = 60
export const sidenavCompactWidth = 80
export const containedLayoutWidth = 1200